import { render, staticRenderFns } from "./TableOrderList.vue?vue&type=template&id=1b67604d&scoped=true"
import script from "./TableOrderList.vue?vue&type=script&lang=js"
export * from "./TableOrderList.vue?vue&type=script&lang=js"
import style0 from "./TableOrderList.vue?vue&type=style&index=0&id=1b67604d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b67604d",
  null
  
)

export default component.exports